export default class MemoryTableModel {
    /* eslint-disable no-use-before-define */
    constructor(items, state = {}, config = {}) {
        this.defaultPageSize = config.defaultPageSize || 25;
        this.init(items, state);
    }

    /**
     *
     * @param state
     */
    init(items, state) {
        this.setState(state);
        this.load(items || []);
    }

    setState(state = {}) {
        this.page = state.page || 1;

        if (this.page < 0) {
            this.page = 1;
        }

        if (state.pageSize && state.pageSize > 0) {
            this.pageSize = state.pageSize;
        } else if (!this.pageSize) {
            this.pageSize = this.defaultPageSize;
        }
    }

    getState() {
        return {
            page: this.page,
            pageSize: this.pageSize,
        };
    }

    load(items) {
        this.all = items;
        this.total = items.length;
        this.refresh();
    }

    refresh() {
        const start = (this.page - 1) * this.pageSize;
        this.items = this.all.slice(start, start + this.pageSize);
    }

    removeRow(row) {
        const idx = this.all.indexOf(row);
        if (idx === -1) {
            return;
        }
        this.all.splice(idx, 1);
        if (this.total) {
            this.total -= 1;
        }
        if (this.items.length - 1) {
            this.refresh();
        } else if (this.page > 1) {
            this.goToPrevious();
        }
    }

    update(diff) {
        const current = this.getState();
        if (!diff.page && this.page !== 1) {
            // eslint-disable-next-line no-param-reassign
            diff.page = 1;
        }
        const newState = Object.assign(current, diff);
        this.setState(newState);
        return this.refresh();
    }

    reset() {
        this.setState({ page: 1 });
        this.update({ page: 1 });
    }

    paging(page, pageSize) {
        return this.update({ page, pageSize });
    }

    goToPage(page) {
        if (page <= 0) {
            return Promise.resolve();
        }
        return this.update({ page });
    }

    goToNext() {
        return this.goToPage(this.page + 1);
    }

    goToPrevious() {
        return this.goToPage(this.page - 1);
    }

    hasItems() {
        return !!this.all.length;
    }

    hasPages() {
        return this.total > 10;
    }
}
